import Model from './Model'

export default class Report extends Model {
  static entity = 'report'

  static fields () {
    return {
      id: this.attr(undefined),
      account_id: this.attr(undefined),
      title: this.attr(undefined),
      start_date: this.attr(undefined),
      end_date: this.attr(undefined),
      status: this.attr(undefined),
      // `data` (frozen snapshot) and `annotations` are only present on the show endpoint
      data: this.attr(undefined),
      annotations: this.attr(undefined),
      by_user_id: this.attr(undefined),
      published_at: this.attr(undefined),
      created_at: this.attr(undefined),
      updated_at: this.attr(undefined),
      deleted_at: this.attr(undefined)
    }
  }
}
